
import { defineComponent, onMounted, onUnmounted, ref } from "vue";
import { getPointingDevice } from "@/scripts/utils";

// Component definition
export default defineComponent({
  name: "AboutLink",
  props: {
    isMouseEnabled: {
      type: Boolean,
      required: true
    }
  },
  setup(props) {
    const pointingDevice = ref<string>(getPointingDevice());
    const isMouseMoved = ref<boolean>(false);

    let mouseTimer = 0;
    const mouseMove = () => {
      if (!props.isMouseEnabled) return;
      clearTimeout(mouseTimer);
      isMouseMoved.value = true;
      mouseTimer = setTimeout(() => {
        isMouseMoved.value = false;
      }, 2000);
    };

    onMounted(() => {
      window.addEventListener("mousemove", mouseMove);
    });
    onUnmounted(() => {
      window.removeEventListener("mousemove", mouseMove);
    });

    return {
      pointingDevice,
      isMouseMoved
    };
  }
});
